/* eslint-disable no-param-reassign */
import { getChannelEntryId } from './channelHelpers';
import { removeListing, removeListingVariant, removeListingVariantIndex } from './entityAdapter';
import { listListingVariantIdsForChannel, listListingVariantIndexForChannel } from './entityReadHelpers';
import { setSelectedChannelByProduct } from './uiAdapter';

export default function removeListingChannelEntities(state, listing) {
  if (!listing?._id) return;

  const listingId = String(listing._id);
  const masterProductId = listing.masterProductId;
  const channelId = getChannelEntryId(listing);

  if (masterProductId && channelId) {
    listListingVariantIdsForChannel(state, masterProductId, channelId).forEach((listingVariantId) => {
      removeListingVariant(state, listingVariantId);
    });
    listListingVariantIndexForChannel(state, masterProductId, channelId).forEach((row) => {
      removeListingVariantIndex(state, row._id);
    });
  }

  Object.values(state.entities?.listingVariants || {}).forEach((listingVariant) => {
    if (String(listingVariant.baseProductId) === listingId) {
      removeListingVariant(state, listingVariant._id);
    }
  });

  removeListing(state, listing._id);

  if (
    masterProductId
    && channelId
    && state.ui?.selectedChannelByProduct?.[masterProductId] === channelId
  ) {
    setSelectedChannelByProduct(state, masterProductId, 'master');
  }
}
